import React, { useEffect, useState } from 'react'
import { Modal, Spin, Row, Image, Button, Checkbox } from 'antd'
import { getCookie } from 'helper/cookie'
import {
  InboxOutlined,
  DownloadOutlined,
  PictureOutlined,
  FileTextOutlined,
  EyeOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import 'styleLess/signature/listFile.scss'
import styled from 'styled-components'
import DeleteFile from './DeleteFile'
import loadingAnimationthreedot from 'icons/three-dots.svg'
const ContainerListFile = styled.div``
const Box = styled.div``
const EmptyState = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}

import GetURL from 'common/GetURLDocument/getURLCommon'

const ListFile = (props) => {
  const { kind, project_id, data, renderData, checkRole } = props
  const token = getCookie('access_token_admin')
  const [listFile, setListFile] = useState(initalState.data)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [titleText, setTitleText] = useState('')
  const [subTitleText, setSubTitleText] = useState('')
  const [eventDelete, setEventDelete] = useState('')
  const [countFile, setCountFile] = useState(0)
  const [getURL, setGetURL] = useState(false)
  const [dataGetURL, setDataGetURL] = useState(false)
  const [dataGetURLType, setDataGetURLType] = useState(false)
  const [loadingGetURL, setLoadingGetURL] = useState(false)
  const [checkedState, setCheckedState] = useState(new Array(data.length).fill(false))
  const ItemDocument = () => {
    if (data.length > 0) {
      return data.map((item, index) => {
        let typeFile = item.filename.split('.')
        // console.log(typeFile[typeFile.length - 1])
        return (
          <div className="itemlist-file-box">
            <Row className="for-responsive-listname">
              <Checkbox
                disabled={checkRole}
                checked={checkedState[index]}
                onChange={(e) => handleSelectFile(e, index)}
                value={item}
              />
              {Icons(typeFile[typeFile.length - 1])}
              <span className="small">{item.filename}</span>
            </Row>
            {showIconsEvent(item)}
          </div>
        )
      })
    } else {
      return (
        <EmptyState className="emytystate">
          <InboxOutlined className="inbox" />
          <p>No Document</p>
        </EmptyState>
      )
    }
  }
  const showIconsEvent = (item) => {
    if (checkRole !== true) {
      return <Row>{typeEvent(item)}</Row>
    }
  }
  const Icons = (type) => {
    if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].includes(type)) {
      return <PictureOutlined className="icontylecolor" />
    } else {
      return <FileTextOutlined className="icontylecolor" />
    }
  }
  const handleSelectFile = (e, indexVal) => {
    if (checkedState) {
      const updatedCheckedState = checkedState.map((item, index) =>
        indexVal === index ? !item : item,
      )
      setCheckedState(updatedCheckedState)
    }
    if (e.target.checked === true) {
      setCountFile(countFile + 1)
      setListFile((prevState) => [...prevState, e.target.value])
    } else {
      setCountFile(countFile - 1)
      let newData = listFile.filter((val) => val.id !== e.target.value.id)
      setListFile(newData)
    }
  }
  const onClickEye = (data, type) => {
    setGetURL(true)
    setDataGetURL(data)
    setDataGetURLType(type)
  }
  useEffect(() => {
    setCheckedState(new Array(data.length).fill(false))
  }, [data])

  const typeEvent = (data) => {
    if (data.can_view === 'Y') {
      return (
        <div className="Eyecontainer">
          {loadingGetURL == true ? (
            <img style={{ width: 24, height: 12 }} src={loadingAnimationthreedot}></img>
          ) : (
            <EyeOutlined
              onClick={() => onClickEye(data, 'preview')}
              className="eyeoutlined"
            />
          )}
        </div>
      )
    } else {
      return (
        <div className="Eyecontainer">
          {loadingGetURL == true ? (
            <img style={{ width: 24, height: 12 }} src={loadingAnimationthreedot}></img>
          ) : (
            <EyeOutlined
              onClick={() => onClickEye(data, 'preview')}
              className="eyeoutlined"
            />
          )}
        </div>
      )
    }
  }
  const onDelete = (event) => {
    // console.log(data)
    if (event === 'deleteAll') {
      setEventDelete('allfile')
      setTitleText('Delete All ?')
      setSubTitleText('Are you sure you want to delete all file ?')
      setVisibleDelete(true)
    } else {
      setEventDelete('customfile')
      setTitleText(`Delete this ${countFile} ${countFile > 1 ? 'files' : 'file'} ?`)
      setSubTitleText(
        `Are you sure you want to delete this ${countFile} ${countFile > 1 ? 'files' : 'file'
        } ?`,
      )
      if (countFile !== 0) {
        setVisibleDelete(true)
      }
    }
    // setId(id)
  }
  const modalDelete = () => {
    return (
      <div>
        <DeleteFile
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          project_id={project_id}
          kind={kind}
          renderData={renderData}
          titleText={titleText}
          subtitleText={subTitleText}
          eventDelete={eventDelete}
          countFile={countFile}
          dataSelect={listFile}
          setCountFile={setCountFile}
          setCheckedState={setCheckedState}
          dataFileInformation={data}
          state={'information'}
        />
      </div>
    )
  }
  if (data.length > 0) {
    return (
      <ContainerListFile className="container-list-file">
        <Box className="overviewBox">{ItemDocument()}</Box>{' '}
        <div className="button-group-style">
          <Button
            hidden={checkRole}
            style={{ marginRight: 10 }}
            onClick={() => onDelete('selectFile')}
            type="primary"
            className="btn_Secondary2"
          >
            <span className="small">
              Delete {countFile} {countFile > 1 ? 'files' : 'file'} Selected
            </span>
          </Button>
          <Button
            hidden={checkRole}
            onClick={() => onDelete('deleteAll')}
            type="primary"
            className="BTN_Warning"
          >
            <span className="small">Delete All</span>
          </Button>
        </div>
        {modalDelete()}
        <GetURL
          project_id={dataGetURL.project_id}
          id_document={dataGetURL.id}
          dataFile={dataGetURL}
          type={dataGetURLType}
          setGetURL={setGetURL}
          getURL={getURL}
          setLoadingGetURL={setLoadingGetURL}
          state="Information"
        />
      </ContainerListFile>
    )
  } else {
    return <> </>
  }
}

export default ListFile
